import { EInviteScoreStatus } from '../types';
import { lang } from '@umu/ukit-lang';

// 评分状态 0 未邀请 1 已邀请 2 已点评 3 已屏蔽

const INVITE_SCORE_STATUS_MAP = {
    [EInviteScoreStatus.NOT_INVITED]: lang('未邀请'),
    [EInviteScoreStatus.INVITED]: lang('已邀请'),
    [EInviteScoreStatus.REVIEWED]: lang('已点评'),
    [EInviteScoreStatus.SHIELDED]: lang('已屏蔽'),
};
const INVITE_SCORE_STATUS_TOAST_MAP = {
    [EInviteScoreStatus.NOT_INVITED]: lang('邀请点评成功'),
    [EInviteScoreStatus.INVITED]: lang('已再次发送邀请通知'),
    [EInviteScoreStatus.REVIEWED]: lang('已点评'),
    [EInviteScoreStatus.SHIELDED]: lang('已屏蔽'),
};

export { INVITE_SCORE_STATUS_MAP, INVITE_SCORE_STATUS_TOAST_MAP };
